import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RealmSelectionComponent } from './realm-selection.component';
import { LoginComponent } from './auth/login/login.component';
import { ProcessService } from "./views/process/process.service";
import { FileOverlayDialogComponent } from "./views/document/file-overlay-dialog/file-overlay-dialog.component";
import { appTitleResolver } from "./resolvers/app-title.resolver";

const routes: Routes = [
  {
    path: 'process',
    loadChildren: () =>
      import('./views/client/client.view.module').then(
        (m) => m.ClientViewModule
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'Login'
  },
  {
    path: '',
    component: RealmSelectionComponent,
    resolve: {
      title: appTitleResolver("selectRealm")
    }
  },
  {
    path: 'intern',
    redirectTo: '/',
  },
  {
    path: 'file-view',
    providers: [ProcessService],
    component: FileOverlayDialogComponent,
  },
  {
    path: ':realm/addon/advoware',
    loadChildren: () => import('./addons/advoware/advoware.module').then(
      (m) => m.AdvowareModule
    ),
  },
  {
    path: ':realm/intern',
    loadChildren: () =>
      import('./views/lawyer/lawyer.view.module').then(
        (m) => m.LawyerViewModule
      ),
  },
  {
    path: ':realm',
    loadChildren: () =>
      import('./views/client/client.view.module').then(
        (m) => m.ClientViewModule
      ),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always' // since behavior changed for angular 17+
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
